// Author thq
// Date 2021-11-01 00:33:42

class EmArchBasicDataRelMaterial {
constructor({
        id = null,
        pkEquip = '',
        pkSparePart = '',
        pkMaterial = '',
        pkMaterialV = '',
        num = '',
        assNum = '',
        unit = '',
        assUnit = '',
        changeRate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.pkEquip = pkEquip;
    this.pkSparePart = pkSparePart;
    this.pkMaterial = pkMaterial;
    this.pkMaterialV = pkMaterialV;
    this.num = num;
    this.assNum = assNum;
    this.unit = unit;
    this.assUnit = assUnit;
    this.changeRate = changeRate;
    this.remark = remark;
}
}

function newEntity() {
return new EmArchBasicDataRelMaterial();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pkEquip',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.pkEquip',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pkSparePart',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.pkSparePart',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pkMaterial',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.pkMaterial',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pkMaterialV',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.pkMaterialV',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'num',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.num',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'assNum',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.assNum',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'unit',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.unit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'assUnit',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.assUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'changeRate',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.changeRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchBasicDataRelMaterial.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    pkEquipFilter : '',
    pkSparePartFilter : '',
    pkMaterialFilter : '',
    pkMaterialVFilter : '',
    numFilter : '',
    assNumFilter : '',
    unitFilter : '',
    assUnitFilter : '',
    changeRateFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'pkEquipFilter',
        label: 'label.em.archive.emArchBasicDataRelMaterial.filter.pkEquip',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkSparePartFilter',
        label: 'label.em.archive.emArchBasicDataRelMaterial.filter.pkSparePart',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkMaterialFilter',
        label: 'label.em.archive.emArchBasicDataRelMaterial.filter.pkMaterial',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkMaterialVFilter',
        label: 'label.em.archive.emArchBasicDataRelMaterial.filter.pkMaterialV',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'numFilter',
        label: 'label.em.archive.emArchBasicDataRelMaterial.filter.num',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'assNumFilter',
        label: 'label.em.archive.emArchBasicDataRelMaterial.filter.assNum',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unitFilter',
        label: 'label.em.archive.emArchBasicDataRelMaterial.filter.unit',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'assUnitFilter',
        label: 'label.em.archive.emArchBasicDataRelMaterial.filter.assUnit',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'changeRateFilter',
        label: 'label.em.archive.emArchBasicDataRelMaterial.filter.changeRate',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'pkEquip',
        label: 'label.em.archive.emArchBasicDataRelMaterial.entity.pkEquip',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkSparePart',
        label: 'label.em.archive.emArchBasicDataRelMaterial.entity.pkSparePart',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkMaterial',
        label: 'label.em.archive.emArchBasicDataRelMaterial.entity.pkMaterial',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkMaterialV',
        label: 'label.em.archive.emArchBasicDataRelMaterial.entity.pkMaterialV',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'num',
        label: 'label.em.archive.emArchBasicDataRelMaterial.entity.num',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'assNum',
        label: 'label.em.archive.emArchBasicDataRelMaterial.entity.assNum',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unit',
        label: 'label.em.archive.emArchBasicDataRelMaterial.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'assUnit',
        label: 'label.em.archive.emArchBasicDataRelMaterial.entity.assUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'changeRate',
        label: 'label.em.archive.emArchBasicDataRelMaterial.entity.changeRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchBasicDataRelMaterial.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmArchBasicDataRelMaterial, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
